module.exports = __webpack_public_path__ + "static/pie4-22c3cc3762e6453d3bc609324567959f.png";